// extracted by mini-css-extract-plugin
export var askAiIcon = "_ob-k";
export var category = "_ob-a";
export var categoryHeader = "_ob-f";
export var container = "_ob-0";
export var group = "_ob-b";
export var groupItems = "_ob-g";
export var groupSeparator = "_ob-l";
export var highlight = "_ob-8";
export var loading = "_ob-1";
export var noResults = "_ob-3";
export var placeholder = "_ob-2";
export var resultContent = "_ob-5";
export var resultIcon = "_ob-d";
export var resultItem = "_ob-h";
export var resultMeta = "_ob-9";
export var resultSubtitle = "_ob-7";
export var resultSuffix = "_ob-j";
export var resultTitle = "_ob-6";
export var resultsList = "_ob-4";
export var searchGroup = "_ob-e";
export var selected = "_ob-i";
export var subgroup = "_ob-c";